export default "__VITE_ASSET__DcGKpDwS__"